<div fxLayout="column">
  <div style="font-size: 18px; font-weight: 400; margin-bottom: 20px">
    {{ 'l10n_fxPlayGround' | translate }}
  </div>
  <div style="width: 100%">
    <mat-card>
      <mat-card-content>
        <div fxLayout="column">
          <div fxLayout="row" fxLayoutAlign="start stretch">
            <div fxFlex="60" fxLayout="column">
              <mat-form-field
                appearance="fill"
                class="expression-block multi-text"
                style="width: 100%"
              >
                <mat-label>{{
                  'l10n_functionExpression' | translate
                }}</mat-label>
                <div>
                  <textarea
                    appAutoFocus
                    matInput
                    class="code-block"
                    [(ngModel)]="expression"
                    rows="25"
                    spellcheck="false"
                  ></textarea>
                  <div
                    fxLayout="row center"
                    fxLayoutGap="10px"
                    style="
                      position: absolute;
                      bottom: 10px;
                      left: 0px;
                      width: 100%;
                    "
                  >
                    <button
                      fxFlex="none"
                      mat-stroked-button
                      class="operation-button"
                      [disabled]="
                        !templateId ||
                        expression === '' ||
                        expression === undefined
                      "
                      (click)="onUpdateTemplateCode()"
                    >
                      <div
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        fxLayoutGap="10px"
                      >
                        <div>{{ 'l10n_updateTemplateCode' | translate }}</div>
                      </div>
                    </button>
                    <button
                      fxFlex="none"
                      mat-stroked-button
                      class="operation-button"
                      style="margin-right: 20px"
                      [disabled]="expression === '' || expression === undefined"
                      (click)="onSaveAsTemplate()"
                    >
                      <div
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        fxLayoutGap="10px"
                      >
                        <div>{{ 'l10n_saveAsTemplate' | translate }}</div>
                      </div>
                    </button>
                    <button
                      fxFlex="none"
                      mat-stroked-button
                      color="warn"
                      class="operation-button"
                      (click)="onReset()"
                    >
                      <div
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        fxLayoutGap="10px"
                      >
                        <div>{{ 'key_reset' | translate }}</div>
                      </div>
                    </button>
                    <div fxFlex="auto"></div>
                    <button
                      fxFlex="none"
                      mat-stroked-button
                      color="primary"
                      class="operation-button"
                      [disabled]="
                        expression === '' ||
                        expression === undefined ||
                        inputParamsForm.invalid ||
                        (templateParamsForm && templateParamsForm.invalid)
                      "
                      (click)="onExecute()"
                    >
                      <div
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        fxLayoutGap="10px"
                      >
                        <div>{{ 'l10n_run' | translate }}</div>
                        <span class="material-icons-outlined"
                          >keyboard_return</span
                        >
                      </div>
                    </button>
                  </div>
                </div>
              </mat-form-field>
              <div
                fxLayout="row"
                fxLayoutAlign="center center"
                style="margin: -5px 0 5px 0"
              >
                <span class="material-icons-outlined">arrow_downward</span>
              </div>
              <div style="width: 100%">
                <div fxLayout="row">
                  <div
                    *ngIf="resultCode !== undefined"
                    style="
                      position: absolute;
                      height: 20px;
                      margin-top: -20px;
                      padding-left: 2px;
                      padding-right: 2px;
                      text-align: center;
                      vertical-align: middle;
                      font-size: 14px;
                      color: white;
                    "
                    [ngClass]="{
                      'label-success': resultState === 'success',
                      'label-error': resultState === 'failed'
                    }"
                  >
                    {{ resultCode }}
                  </div>
                  <mat-form-field
                    fxFlex="auto"
                    appearance="fill"
                    subscriptSizing="dynamic"
                    style="width: 100%"
                    class="multi-text"
                    [ngClass]="{
                      'box-success': resultState === 'success',
                      'box-error': resultState === 'failed'
                    }"
                  >
                    <mat-label>{{ 'key_viewResults' | translate }}</mat-label>
                    <mat-spinner
                      *ngIf="isLoading"
                      [diameter]="40"
                      style="
                        position: absolute;
                        left: calc(50% - 20px);
                        top: calc(50% - 20px);
                      "
                    ></mat-spinner>
                    <textarea
                      matInput
                      subscriptSizing="dynamic"
                      class="code-block"
                      rows="6"
                      spellcheck="false"
                      [readonly]="true"
                      [value]="expressionResultString"
                    ></textarea>
                  </mat-form-field>
                  <div
                    fxFlex="none"
                    fxLayout="column"
                    fxLayoutGap="5px"
                    style="margin-left: 10px"
                  >
                    <button
                      fxFlex="none"
                      mat-stroked-button
                      class="operation-button"
                      [ngClass]="{
                        'toggled-button':
                          expressionResultString && resultMode === 'json'
                      }"
                      [disabled]="
                        expressionResultString === '' ||
                        expressionResult === undefined
                      "
                      style="display: none"
                      (click)="onJsonData()"
                    >
                      <div
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap="10px"
                      >
                        <span fxFlex="30px" class="material-icons-outlined"
                          >segment</span
                        >
                        <div>{{ 'l10n_json' | translate }}</div>
                      </div>
                    </button>
                    <button
                      fxFlex="none"
                      mat-stroked-button
                      class="operation-button"
                      [ngClass]="{
                        'toggled-button':
                          expressionResultString && resultMode === 'raw'
                      }"
                      [disabled]="
                        expressionResultString === '' ||
                        expressionResult === undefined
                      "
                      style="display: none"
                      (click)="onRawData()"
                    >
                      <div
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap="10px"
                      >
                        <span fxFlex="30px" class="material-icons-outlined"
                          >raw_on</span
                        >
                        <div>{{ 'l10n_raw' | translate }}</div>
                      </div>
                    </button>
                    <button
                      fxFlex="none"
                      mat-stroked-button
                      class="operation-button"
                      [disabled]="
                        expressionResultString === '' ||
                        expressionResult === undefined
                      "
                      (click)="onCopyData()"
                    >
                      <div
                        fxLayout="row"
                        fxLayoutAlign="start center"
                        fxLayoutGap="10px"
                      >
                        <span
                          fxFlex="30px"
                          class="material-icons-outlined"
                          style="font-size: 18px"
                          >content_copy</span
                        >
                        <div>{{ 'key_copy' | translate }}</div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div fxFlex="40" class="config-dialog" style="margin-left: 20px">
              <mat-accordion>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ 'l10n_fxTemplate' | translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div fxLayout="column">
                    <div
                      fxFlex="610px"
                      fxLayout="column"
                      style="overflow-x: hidden; overflow-y: auto"
                    >
                      <app-editor-identity
                        #idpTemplate
                        style="margin-top: 5px"
                        [(ngModel)]="templateResource"
                        [creationMode]="true"
                        [config]="idpTemplateConfig"
                        (valueChange)="onTemplateChange($event)"
                        (dbClick)="onIdentityDoubleClick($event)"
                      ></app-editor-identity>
                      <div *ngIf="templateId; else noTemplateId">
                        <div style="font-weight: 400; margin-bottom: 10px">
                          {{ 'key_inputParameters' | translate }}
                        </div>
                        <div
                          *ngFor="let parameter of parameterConfig"
                          fxLayout="row"
                          fxLayoutAlign="start center"
                          fxLayoutGap="10px"
                          class="background-bg-color"
                          style="padding: 5px; margin-bottom: 5px"
                        >
                          <div
                            fxFlex="200px"
                            fxLayout="column"
                            style="cursor: default"
                            [matTooltip]="parameter.displayname"
                          >
                            <div
                              style="overflow: hidden"
                              [style.margin-bottom]="
                                parameter.description ? '-5px' : '0px'
                              "
                            >
                              {{ parameter.paramKey | translate }}
                            </div>
                            <div
                              class="accent-text-color"
                              style="
                                font-size: 0.75em;
                                margin-bottom: -5px;
                                margin-top: 5px;
                                line-height: 15px;
                                font-weight: 400;
                              "
                            >
                              {{ parameter.description | translate }}
                            </div>
                          </div>
                          <mat-form-field fxFlex="auto" style="font-size: 12px">
                            <mat-label>{{ 'key_value' | translate }}</mat-label>
                            <input
                              matInput
                              [(ngModel)]="parameter.paramValue"
                            />
                          </mat-form-field>
                          <mat-form-field
                            fxFlex="auto"
                            style="font-size: 12px; display: none"
                          >
                            <mat-label>{{
                              'key_defaultValue' | translate
                            }}</mat-label>
                            <input
                              matInput
                              disabled
                              [(ngModel)]="parameter.defaultvalue"
                            />
                          </mat-form-field>
                          <div
                            fxFlex="100px"
                            style="
                              margin-left: 20px;
                              padding-left: 5px;
                              border-left: solid 4px darkseagreen;
                              font-size: 12px;
                            "
                          >
                            {{ parameter.datatype }}
                          </div>
                        </div>
                      </div>
                      <ng-template #noTemplateId>
                        <form autocomplete="off" #templateParamsForm="ngForm">
                          <app-editor-iterables
                            #itrTemplateParameter
                            name="itrTemplateParameter"
                            [config]="configTemplateParameter"
                            [(ngModel)]="templateParameter"
                          ></app-editor-iterables>
                        </form>
                      </ng-template>
                    </div>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ 'l10n_parameters' | translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div fxLayout="column">
                    <div
                      fxFlex="550px"
                      fxLayout="column"
                      style="overflow-x: hidden; overflow-y: auto"
                    >
                      <app-editor-identity
                        #idpRequestor
                        style="margin-top: 5px"
                        [(ngModel)]="requestorResource"
                        [creationMode]="true"
                        [config]="{
                          showPhoto: true,
                          allowEmptySearch: true,
                          queryNormalSearch:
                            '/person[starts-with(DisplayName,\'%SearchText%\') or starts-with(AccountName,\'%SearchText%\') or ObjectID=\'%SearchText%\']',
                          queryEmptySearch:
                            '/person[starts-with(DisplayName,\'%\')]',
                          attributesToShow: [
                            {
                              field: 'DisplayName',
                              width: 0,
                              filterable: true,
                              filter: 'text',
                              sortable: true
                            },
                            {
                              field: 'AccountName',
                              width: 0,
                              filterable: true,
                              filter: 'text',
                              sortable: true
                            }
                          ]
                        }"
                        (dbClick)="onIdentityDoubleClick($event)"
                      ></app-editor-identity>
                      <app-editor-identity
                        #idpTarget
                        [(ngModel)]="targetResource"
                        [creationMode]="true"
                        [config]="{
                          allowEmptySearch: true,
                          browserShowTypePicker: true,
                          queryNormalSearch:
                            '/*[starts-with(DisplayName,\'%SearchText%\')]',
                          queryEmptySearch:
                            '/*[starts-with(DisplayName,\'%\')]',
                          attributesToShow: [
                            {
                              field: 'DisplayName',
                              width: 0,
                              filterable: true,
                              filter: 'text',
                              sortable: true
                            },
                            {
                              field: 'ObjectType',
                              width: 0,
                              filterable: true,
                              filter: 'text',
                              sortable: true
                            }
                          ]
                        }"
                        (dbClick)="onIdentityDoubleClick($event)"
                      ></app-editor-identity>
                      <form autocomplete="off" #inputParamsForm="ngForm">
                        <app-editor-iterables
                          #itrWorkflowData
                          name="itrWorkflowData"
                          [config]="configWorkflowDataExpression"
                          [ngModel]="workflowDataExpression"
                        ></app-editor-iterables>
                        <app-editor-iterables
                          #itrDelta
                          name="itrDelta"
                          [config]="configDeltaExpression"
                          [ngModel]="deltaExpression"
                          style="margin-top: 10px"
                        ></app-editor-iterables>
                        <app-editor-iterables
                          #itrDeltaBeforeChange
                          name="itrDeltaBeforeChange"
                          [config]="configDeltaExpression"
                          [ngModel]="deltaBeforeChangeDataExpression"
                          style="margin-top: 10px"
                        ></app-editor-iterables>
                      </form>
                    </div>
                    <div
                      fxFlex="none"
                      fxLayout="row"
                      fxLayoutAlign="start center"
                      style="margin-top: 20px"
                    >
                      <!-- <button
                        fxFlex="none"
                        mat-stroked-button
                        color="primary"
                        class="operation-button"
                        [disabled]="expression === '' || expression === undefined"
                        (click)="onExecute()"
                      >
                        <div
                          fxLayout="row"
                          fxLayoutAlign="center center"
                          fxLayoutGap="10px"
                        >
                          <div>{{ 'l10n_run' | translate }}</div>
                          <span class="material-icons-outlined">keyboard_return</span>
                        </div>
                      </button> -->
                      <div fxFlex="auto"></div>
                      <button
                        fxFlex="none"
                        mat-stroked-button
                        class="operation-button"
                        style="margin-right: 5px"
                        [disabled]="
                          expression === '' || expression === undefined
                        "
                        (click)="onSaveExpression()"
                      >
                        <div
                          fxLayout="row"
                          fxLayoutAlign="center center"
                          fxLayoutGap="10px"
                        >
                          <div>{{ 'key_save' | translate }}</div>
                        </div>
                      </button>
                      <mat-form-field
                        appearance="outline"
                        subscriptSizing="dynamic"
                        style="margin-right: 5px"
                        class="saved-expressions"
                      >
                        <mat-select [(value)]="selectedExpression">
                          <mat-option
                            *ngFor="let exp of expressions"
                            [value]="exp"
                            style="font-size: 14px; height: 32px"
                          >
                            {{ exp.key }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <button
                        fxFlex="none"
                        mat-stroked-button
                        class="operation-button"
                        style="margin-right: 5px"
                        [disabled]="!selectedExpression"
                        (click)="onLoadExpression()"
                      >
                        <div
                          fxLayout="row"
                          fxLayoutAlign="center center"
                          fxLayoutGap="10px"
                        >
                          <div>{{ 'key_load' | translate }}</div>
                        </div>
                      </button>
                      <button
                        fxFlex="none"
                        mat-stroked-button
                        class="operation-button"
                        color="warn"
                        [disabled]="!selectedExpression"
                        (click)="onDeleteExpression()"
                      >
                        <div
                          fxLayout="row"
                          fxLayoutAlign="center center"
                          fxLayoutGap="10px"
                        >
                          <div>{{ 'key_delete' | translate }}</div>
                        </div>
                      </button>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
